import { prop } from '@ipfabric/utils/fp/prop';
import { createSelector } from 'reselect';
import { createScopedSelector } from 'utils/react/scopedSelector';
import type { MultiplesGeneratorMergedState } from '../MultiplesGeneratorModel';

/**
 * Example of a selector for the command model
 *
 * The selector can be basically any function in one of these forms:
 * - `(s: MultiplesGeneratorModel) => T` - it can be used only in context selectors
 *   (or in the root orchestration component) because it requires the whole model,
 *   which is not available to commands.
 * - `(s: MultiplesGeneratorMergedState) => T` - it can be used both in commands
 *    by passing `getState()` as an argument or in context selectors as described above.
 *
 * @see createScopedSelector
 *
 */
export const selectMultiple: (
  s: MultiplesGeneratorMergedState,
) => number | null = createScopedSelector(() =>
  createSelector(
    // you can use selectors here too for multi-level memoization
    prop('multiplier'),
    prop('baseNumber'),
    (multiplier, baseNumber) =>
      multiplier === null ? null : multiplier * baseNumber,
  ),
);
